export default "__VITE_ASSET__B8ifpsP5__"